import React, { useState } from "react";
import { Download as DownloadIcon } from "@mui/icons-material";

const DownloadableImage = ({ imageSrc }) => {

  const [isHovered, setIsHovered] = useState(false);

  const handleDownloadClick = () => {
    // Create a link element
    const link = document.createElement("a");
    link.href = imageSrc;
    link.download = "downloaded-image.jpg"; // Name of the file to be downloaded
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div
      style={{
        position: "relative",
        display: "inline-block",
        width: "200px",
        borderRadius: "10px",
        overflow: "hidden",
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <img
        src={imageSrc}
        alt=""
        style={{
          width: "100%",
          borderRadius: "10px",
          display: "block",
        }}
      />
      {isHovered && (
        <div
          onClick={handleDownloadClick}
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            cursor: "pointer",
            borderRadius: "10px",
          }}
        >
          <DownloadIcon style={{ fontSize: 32, color: "white" }} />
        </div>
      )}
    </div>
  );
};

export default DownloadableImage;
